import { useEffect } from 'react';
import { useMe } from '@/account/profile/api';
import { useHasAccessToken } from '@/auth/api';
import { inAppMessage } from './inAppMessage';

export const useInAppMessage = () => {
  const hasAccessToken = useHasAccessToken();
  const me = useMe();

  useEffect(() => {
    if (hasAccessToken && me?.data?.key) {
      inAppMessage.loadScript();
      const identifyData: {
        id: string;
        email?: string;
        phone?: string;
      } = {
        id: me.data.key,
      };

      if (me.data.email) {
        identifyData.email = me.data.email;
      } else if (me.data.phone_number) {
        identifyData.phone = me.data.phone_number;
      }

      inAppMessage.identify(identifyData);
    }
  }, [hasAccessToken, me.data]);

  return inAppMessage;
};
